import styled from 'styled-components';
import { secundaryButton } from '../../../global.style';
export const ButtonContainer = styled.div `
  width: 66px;
  text-align: -webkit-right;
  margin-right: 32px;

  .badge {
    position: absolute;
    top: 10px;
    right: 12px;
    width: 7px;
    height: 7px;
    border-radius: var(--border-radius-circular);
    pointer-events: none;
  }

  .red {
    background-color: var(--color-feedback-danger-300);
  }

  .gray {
    background-color: var(--color-neutral-300);
  }

  .tooltip {
    position: relative;
    display: inline-block;
  }

  .tooltip .tooltiptext {
    visibility: hidden;
    background-color: var(--color-neutral-400);
    color: var(--color-contrast-white) !important;
    text-align: center;
    padding: 10px 6px;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    width: 150px;
    top: 100%;
    left: 50%;
    margin-left: -60px;
    font-weight: normal !important;
    font-size: var(--font-size-xs);
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }

  button {
    ${secundaryButton}

    cursor: pointer;
    width: var(--main-menu-size);
    height: var(--main-menu-size);
    margin: 0px var(--main-menu-padding) 0 var(--main-menu-padding);
    border: none;
    background-color: transparent;
    border-radius: var(--border-radius-circular);
  }
`;
//# sourceMappingURL=style.js.map